export const SESSION_COOKIE_NAME = "lux_uid";
